export default "__VITE_ASSET__B2iPnH_H__"